import React from 'react';
import { motion } from 'framer-motion';
export function About() {
  const pills = [{
    icon: '🔥',
    text: 'Parrilla'
  }, {
    icon: '🌿',
    text: 'Patio al aire libre'
  }, {
    icon: '🎶',
    text: 'Shows en vivo'
  }, {
    icon: '🍹',
    text: 'Barra de tragos'
  }, {
    icon: '☕',
    text: 'Allegra Café'
  }];
  return <section id="nosotros" className="py-24 bg-matambrito-black relative" data-id="element-14">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-15">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-20 items-center" data-id="element-16">
          {/* Image Column */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8
        }} className="relative" data-id="element-17">
            <div className="aspect-[4/5] rounded-2xl overflow-hidden shadow-2xl relative z-10" data-id="element-18">
              <img src="https://cdn.magicpatterns.com/uploads/qDT2PCXn65NuS2bSgfDDM2/WhatsApp_Image_2026-04-14_at_16.23.43_(1).jpg" alt="Leo y Mary, dueños de El Matambrito" className="w-full h-full object-cover" data-id="element-19" />
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent" data-id="element-20"></div>
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 bg-matambrito-red-dark/20 rounded-full blur-3xl -z-10" data-id="element-21"></div>
            <div className="absolute -top-6 -left-6 w-32 h-32 bg-matambrito-gold/10 rounded-full blur-2xl -z-10" data-id="element-22"></div>
            <div className="absolute bottom-6 left-6 bg-matambrito-black/80 backdrop-blur-md border border-white/10 p-4 rounded-lg z-20 shadow-xl" data-id="element-23">
              <p className="font-serif italic text-matambrito-gold text-lg" data-id="element-24">
                "El alma del lugar"
              </p>
            </div>
          </motion.div>

          {/* Text Column */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="bg-wood-texture bg-cover bg-center rounded-2xl p-8 md:p-12 relative overflow-hidden shadow-2xl" data-id="element-25">
            <div className="absolute inset-0 bg-matambrito-charcoal/90 mix-blend-multiply" data-id="element-26"></div>
            <div className="absolute inset-0 bg-gradient-to-br from-black/80 to-transparent" data-id="element-27"></div>

            <div className="relative z-10" data-id="element-28">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-matambrito-cream mb-8" data-id="element-29">
                Bienvenidos a{' '}
                <span className="text-matambrito-gold" data-id="element-30">nuestro patio</span>
              </h2>

              <div className="space-y-6 text-matambrito-beige text-lg leading-relaxed font-light" data-id="element-31">
                <p data-id="element-32">
                  El Matambrito nació de algo muy simple: las ganas de crear un
                  espacio donde la gente se sienta bien.
                </p>
                <p data-id="element-33">
                  Leo y Mary son los dueños y el alma de este lugar. Siempre
                  presentes, siempre cerca. Porque para ellos lo más importante
                  no es solo lo que sale de la cocina, sino cómo te sentís
                  cuando estás acá.
                </p>
                <p data-id="element-34">
                  Vas a encontrarlos recorriendo el patio, charlando con las
                  mesas, haciendo que cada visita se sienta como una bienvenida
                  de verdad. Esa calidez no se aprende — es simplemente quiénes
                  son.
                </p>
                <p data-id="element-35">
                  Hoy El Matambrito es mucho más que un lugar para comer. Es un
                  patio gastronómico donde la parrilla se mezcla con los shows
                  en vivo, los tragos bien preparados y el café con pastelería
                  de Allegra. Acá no hay apuro. Hay fuego, hay música y hay dos
                  personas que genuinamente se alegran de verte.
                </p>

                <div className="pt-4 pb-2" data-id="element-36">
                  <p className="font-serif text-2xl text-matambrito-cream italic" data-id="element-37">
                    — Leo y Mary 🤝
                  </p>
                </div>
              </div>

              {/* Pills */}
              <div className="mt-10 flex flex-wrap gap-3" data-id="element-38">
                {pills.map((pill, index) => <div key={index} className="flex items-center gap-2 bg-matambrito-black/60 border border-matambrito-gold/20 px-4 py-2 rounded-full text-sm text-matambrito-cream backdrop-blur-sm" data-id="element-39">
                    <span data-id="element-40">{pill.icon}</span>
                    <span data-id="element-41">{pill.text}</span>
                  </div>)}
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}